module.exports = __webpack_public_path__ + "img/Pag7.3da3e362.png";